import { render, staticRenderFns } from "./insurancepackages.vue?vue&type=template&id=58b1f831"
import script from "./insurancepackages.vue?vue&type=script&lang=js"
export * from "./insurancepackages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports